import classnames from "classnames";
import { FileGeneric, Check, Close } from "neetoicons";

import Progress from "./Progress";
import { convertBytesToMb } from "./utils";

const FilePreview = ({ file, isUploading, cancel, progress }) => (
  <li
    className="neeto-molecules-file-upload__uploaded-list-item"
    key={file.url}
  >
    <div className="neeto-molecules-file-upload__file-preview">
      <a
        className={classnames({ "neeto-molecules-invisible": isUploading })}
        href={file.url}
        rel="noreferrer"
        target="_blank"
      >
        <FileGeneric />
      </a>
      {isUploading && (
        <div className="neeto-molecules-progress">
          <Progress percents={progress || 0} size={20} />
        </div>
      )}
    </div>
    <div className="neeto-molecules-file-upload__file-info">
      <span
        className="neeto-molecules-file-upload__file-info-name"
        data-testid="file-name"
      >
        {file.name}
      </span>
      <span className="neeto-molecules-file-upload__file-info-size">
        {file.size ? `${convertBytesToMb(file.size)} MB` : ""}
      </span>
    </div>
    <div className="neeto-molecules-file-upload__actions">
      <span
        className={classnames(
          "neeto-molecules-file-upload__success-indicator",
          { "neeto-molecules-file-upload__success-indicator--active": file.url }
        )}
      >
        {file.url && <Check data-testid="file-upload-success" />}
      </span>
      <button
        className="neeto-molecules-file-upload__button--red neeto-molecules-file-upload__remove-button"
        type="button"
        onClick={cancel}
      >
        <Close />
      </button>
    </div>
  </li>
);

export default FilePreview;
